import React from "react";
import auth from "../../api/auth";
import { NavLink } from "react-router-dom";
import Button from "../subcomponents/controls/button";
import { connect } from "react-redux";
import config from "../../config";

class MenuItems extends React.Component {
  userNonSetup() {
    return (
      <div className="menu">
        {this.orbitClient()}
        <ul>
          <li>
            <NavLink activeClassName={"active_menu"} to="/events_list">
              Races List
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/subscribers_list">
              Subscribers
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/calendar">
              Calendar
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/logout">
              Logout
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }

  orbitClient() {
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          label="Download client"
          onClick={() => {
            window.open(config.client_download_url, "_blank");
          }}
        />
        <div className="links">
          <a target="_blank" className="link" rel="noreferrer" href={config.client_manual_url}>
            Client manual
          </a>
          <a target="_blank" className="link" rel="noreferrer" href={config.client_logos_manual_url}>
            Brand name manual
          </a>
        </div>
      </div>
    );
  }

  adminNonSetup() {
    return (
      <div className="menu">
        {this.orbitClient()}
        <ul>
          <li>
            <NavLink activeClassName={"active_menu"} to="/events_list">
              Races List
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/subscribers_list">
              Subscribers
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/calendar">
              Calendar
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/mqtt_log">
              MQTT Log
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/logout">
              Logout
            </NavLink>
          </li>
        </ul>
        <Button
          name="setup_mode"
          label="Setup"
          onClick={this.props.setSetupMode}
        />
      </div>
    );
  }

  adminSetup() {
    return (
      <div className="menu">
        {this.orbitClient()}
        <ul>
          <li>
            <NavLink activeClassName={"active_menu"} to="/events_list">
              Races List
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/subscribers_list">
              Subscribers
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/calendar">
              Calendar
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/mqtt_log">
              MQTT Log
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/admin_list">
              Admins
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/companies_list">
              Companies
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/subscriptions_list">
              Subscriptions
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/controller_list">
              Controllers
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/module_list">
              Modules
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/config">
              Config
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/logs_list">
              Logs
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName={"active_menu"} to="/logout">
              Logout
            </NavLink>
          </li>
        </ul>
        <Button
          name="un_setup_mode"
          label="Exit setup"
          onClick={this.props.unsetSetupMode}
        />
      </div>
    );
  }

  render() {
    if (!auth.isAuth()) {
      return null;
    } else {
      if (this.props.role === "User" && this.props.setup_mode) {
        return null;
      } else {
        if (!this.props.setup_mode) {
          if (this.props.role === "User") {
            return this.userNonSetup();
          } else {
            return this.adminNonSetup();
          }
        } else {
          return this.adminSetup();
        }
      }
    }
  }
}

function mapStateToProps(state) {
  return {
    setup_mode: state.systemR.setup_mode,
    role: state.authR.user.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSetupMode() {
      dispatch({
        type: "SET_SETUP_MODE",
      });
    },
    unsetSetupMode() {
      dispatch({
        type: "UNSET_SETUP_MODE",
      });
    },
  };
}

export default MenuItems = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuItems);
